// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FloatingMessagesDate_root__QAQLA {
  position: sticky;
  top: 10px;
  width: 100%;
  padding: 8px 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  pointer-events: none;
  opacity: 1;
}
.FloatingMessagesDate_rootInvisible__s7Sfp {
  opacity: 0;
  pointer-events: none;
  transition: 0.7s 0.5s opacity;
}

.FloatingMessagesDate_item__IyUXE {
  -webkit-user-select: none;
          user-select: none;
  padding: 4px 8px;
  display: inline-block;
  background: white;
  border-radius: 12px;
}

.FloatingMessagesDate_text__Y3zuW {
  color: #8E8E93;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/FloatingMessagesDate/FloatingMessagesDate.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EAEA,SAAA;EAEA,WAAA;EACA,cAAA;EACA,UAAA;EAEA,aAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;AAHF;AAKE;EACE,UAAA;EACA,oBAAA;EAEA,6BAAA;AAJJ;;AASA;EAME,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAXF","sourcesContent":[".root {\n  position: sticky;\n  //z-index: 10;\n  top: 10px;\n  //margin-top: 10px;\n  width: 100%;\n  padding: 8px 0;\n  z-index: 1;\n\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n\n  opacity: 1;\n\n  &Invisible {\n    opacity: 0;\n    pointer-events: none;\n\n    transition: 0.7s 0.5s opacity;\n    //animation: 0.5s 0.5s fade forwards;\n  }\n}\n\n.item {\n  //position: absolute;\n  //top: 0;\n  //left: 0;\n  //transform: translateX(-50%);\n\n  user-select: none;\n  padding: 4px 8px;\n  display: inline-block;\n  background: white;\n  border-radius: 12px;\n}\n\n.text {\n  color: #8E8E93;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n}\n\n//@keyframes fade {\n//  from {\n//    opacity: 1;\n//  }\n//  to {\n//    opacity: 0;\n//  }\n//}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FloatingMessagesDate_root__QAQLA`,
	"rootInvisible": `FloatingMessagesDate_rootInvisible__s7Sfp`,
	"item": `FloatingMessagesDate_item__IyUXE`,
	"text": `FloatingMessagesDate_text__Y3zuW`
};
export default ___CSS_LOADER_EXPORT___;
